import React, { Component } from 'react'
import PropTypes from 'prop-types'
import autobind from 'autobind-decorator'

class SkinCardTags extends Component {

	@autobind
	handleChangeFilter(e, layout) {
		const { onChangeFilter } = this.props
		e.preventDefault()
    onChangeFilter(layout)
	}

	getLayoutInfo() {
		const { skin } = this.props
		const layout = skin.layout
		if (typeof layout === 'undefined') {
			return null
		}

		switch(layout) {
			case 'responsive':
				return {
					name: layout,
					label: '반응형'
				}
			case 'etc':
				return {
					name: '2',
					label: '2단형'
				}
			default:
				return {
					name: layout,
					label: layout + '단형'
				}
		}
	}

	render() {
		const { skin } = this.props

		const layout = this.getLayoutInfo()

		return (
			<div className="bundle_tag">
				{layout &&
					<a href="#" target="_blank" className="link_tag" onClick={(e) => {this.handleChangeFilter(e, layout.name)}}>
						#{layout.label}
					</a>
				}
				{skin.isEditableMenu == '1' &&(
					<a href="#" target="_blank" className="link_tag" onClick={(e) => {this.handleChangeFilter(e, 'EDITABLE_MENU')}}>{'#메뉴 지원'}</a>
				)}
				{skin.wizard == '1' &&(
					<a href="#" className="link_tag" onClick={(e) => {this.handleChangeFilter(e, 'SKIN_WIZARD')}}>{'#스킨위자드 지원'}</a>
				)}
			</div>
		)
	}
}

SkinCardTags.propTypes = {
	skin: PropTypes.object,
    onChangeLayout: PropTypes.func
}
export default SkinCardTags
